import type { CSSProperties } from 'react'

export interface ContactModalPalette {
  background: string
  surface: string
  text: string
  muted: string
  buttonBackground: string
  buttonHover: string
  buttonText: string
}

/** Portal colours are branding data; no component needs to know the shop ID. */
export const resolveContactModalPalette = (palette?: ContactModalPalette) => ({
  ink: palette?.text || '#2a211a',
  border: palette?.text || '#5b4636',
  white: palette?.buttonText || '#fffaf4',
  accent: palette?.buttonBackground || '#7e634b',
  shadow: palette?.buttonHover || '#4e392a',
  dialogShadow: palette?.buttonHover || '#0d0a07',
  chipShadow: palette?.buttonHover || '#271f18',
  mutedOpacity: palette ? .8 : .68,
  variables: palette ? {
    '--page-builder-background': palette.background,
    '--page-builder-surface': palette.surface,
    '--page-builder-text': palette.text,
    '--page-builder-muted': palette.muted,
    '--page-builder-button-bg': palette.buttonBackground,
    '--page-builder-button-hover': palette.buttonHover,
    '--page-builder-button-text': palette.buttonText,
  } as CSSProperties : undefined,
})
